import layoutAdmin from '@/layouts/layoutAdmin.vue';
import hrmDepartmentSetup from '@/views/module/hrm/settingsManagement/hrmDepartmentSetup.vue';
import hrmDesignationSetup from '@/views/module/hrm/settingsManagement/hrmDesignationSetup.vue';
import hrmEmployeeHODSetup from '@/views/module/hrm/settingsManagement/hrmEmployeeHODSetup.vue';
import hrmAddEmployee from '@/views/module/hrm/employeesManagement/hrmAddEmployee.vue';
import hrmEmployeeType from '@/views/module/hrm/employeesManagement/hrmEmployeeType.vue';
import hrmEmployeeList from '@/views/module/hrm/employeesManagement/hrmEmployeeList.vue';
import hrmEmployeeDetails from '@/views/module/hrm/employeesManagement/hrmEmployeeDetails.vue';
import hrmSectionSetup from '@/views/module/hrm/settingsManagement/hrmSectionSetup.vue';
import hrmAddNominee from '@/views/module/hrm/employeesManagement/hrmAddNominee.vue';
import hrmNomineeList from '@/views/module/hrm/employeesManagement/hrmNomineeList.vue';
import hrmIncrementList from '@/views/module/hrm/incrementManagement/hrmIncrementList.vue';
import hrmAddIncrement from '@/views/module/hrm/incrementManagement/hrmAddIncrement.vue';
import hrmPromotionList from '@/views/module/hrm/promotionManagement/hrmPromotionList.vue';
import hrmAddPromotion from '@/views/module/hrm/promotionManagement/hrmAddPromotion.vue';
import hrmBloodGroupReport from '@/views/module/hrm/reports/hrmBloodGroupReport.vue';
import hrmJoiningReport from '@/views/module/hrm/reports/hrmJoiningReport.vue';
import hrmIncrementReport from '@/views/module/hrm/reports/hrmIncrementReport.vue';
import hrmPromotionReport from '@/views/module/hrm/reports/hrmPromotionReport.vue';
import hrmNomineeReport from '@/views/module/hrm/reports/hrmNomineeReport.vue';
import hrmEmployeeSummaryReport from '@/views/module/hrm/reports/hrmEmployeeSummaryReport.vue';
import hrmEmployeeBankSetup from '@/views/module/hrm/settingsManagement/hrmEmployeeBankSetup.vue';
import hrmLetterInfoSetup from '@/views/module/hrm/settingsManagement/hrmLetterInfoSetup.vue';
import hrmLetterRecords from '@/views/module/hrm/settingsManagement/hrmLetterRecords.vue';

export default [
    {
      path: '/hrm',
      component: layoutAdmin,
      meta: {
        UserLoggedIn: true,
        breadcrumb: 'Human Resource Management',
      },
      children: [
        {
          path: "department",
          meta: {
            breadcrumb: ['Department']
          },
          component: hrmDepartmentSetup,
        },

        {
          path: "section",
          meta: {
            breadcrumb: ['Section']
          },
          component: hrmSectionSetup,
        },
        {
          path: "letter-info-setup",
          meta: {
            breadcrumb: ['Letter Info Setup']
          },
          component: hrmLetterInfoSetup,
        },
        {
          path: "letter-records",
          meta: {
            breadcrumb: ['Letter Records']
          },
          component: hrmLetterRecords,
        },
        {
          path: "employee-bank-setup",
          meta: {
            breadcrumb: ['Employee Bank Setup']
          },
          component: hrmEmployeeBankSetup,
        },
        {
          path: "designation",
          meta: {
            breadcrumb: ['Designation']
          },
          component: hrmDesignationSetup,
        },
        {
          path: "add-employee",
          meta: {
            breadcrumb: ['Add Employee']
          },
          component: hrmAddEmployee,
        },
        {
          path: "employee-type",
          meta: {
            breadcrumb: ['Employee Type']
          },
          component: hrmEmployeeType,
        },
        {
          path: "employee-list",
          meta: {
            breadcrumb: ['Employee List']
          },
          component: hrmEmployeeList,
        },
        {
          path: "add-nominee",
          meta: {
            breadcrumb: ['Add Nominee']
          },
          component: hrmAddNominee,
        },
        {
          path: "nominee-list",
          meta: {
            breadcrumb: ['Nominee List']
          },
          component: hrmNomineeList,
        },
        {
          path: "employee-details/:id",
          name: "employee-details",
          meta: {
            breadcrumb: ['Employee Details']
          },
          component: hrmEmployeeDetails,
        },
        {
          path: "department-head",
          meta: {
            breadcrumb: ['HOD Setup']
          },
          component: hrmEmployeeHODSetup,
        },
        {
          path: "increment-list",
          meta: {
            breadcrumb: ['Increment Management']
          },
          component: hrmIncrementList,
        },
        {
          path: "add-increment",
          name: "add-increment",
          meta: {
            breadcrumb: ['Add Increment']
          },
          component: hrmAddIncrement,
        },
        {
          path: "promotion-list",
          meta: {
            breadcrumb: ['Promotion Management']
          },
          component: hrmPromotionList,
        },
        {
          path: "add-promotion",
          name: "add-promotion",
          meta: {
            breadcrumb: ['Add Promotion']
          },
          component: hrmAddPromotion,
        },
        {
          path: "blood-group-report",
          meta: {
            breadcrumb: ['Blood Group Report']
          },
          component: hrmBloodGroupReport,
        },
        {
          path: "joining-report",
          meta: {
            breadcrumb: ['Joining Report']
          },
          component: hrmJoiningReport,
        },
        {
          path: "increment-report",
          meta: {
            breadcrumb: ['Increment Report']
          },
          component: hrmIncrementReport,
        },
        {
          path: "promotion-report",
          meta: {
            breadcrumb: ['Promotion Report']
          },
          component: hrmPromotionReport,
        },
        {
          path: "nominee-report",
          meta: {
            breadcrumb: ['Nominee Report']
          },
          component: hrmNomineeReport,
        },
        {
          path: "employee-summary-report",
          meta: {
            breadcrumb: ['Employee Summary Report']
          },
          component: hrmEmployeeSummaryReport,
        },
        
      ],
      
    },
    
  ]


  